// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9651) return "static/chunks/9651.837f560f2d2b2379.js";
	if (chunkId === 1281) return "static/chunks/SearchPage.17f7734d05af19a3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"516":"a965e41329799ac7","6414":"62c8cc9dc62d21f5","7379":"cb307a6dd66739e1"}[chunkId] + ".js";
};